module.exports = __webpack_public_path__ + "img/loading.3ccd4c2b.gif";